import { AsyncFunction } from '@egr/xbox/utils/Types';
import { WrappedError, sentryShouldIgnoreError } from '@egr/xbox/utils/Error';

export class InvalidInputFileError extends WrappedError {
    public constructor(error: Error) {
        super(error);

        Object.setPrototypeOf(this, InvalidInputFileError.prototype);
    }
}

export class FatalErrorWithCustomMessage extends WrappedError {
    public constructor(
        error: Error,
        public readonly headline: string,
        public readonly buttons?: Array<{
            key: string;
            label: string,
            callback: AsyncFunction,
            doNotCloseDialog?: boolean
        }>,
        errorMessage?: string,
        doNotLog?: boolean,
        public readonly additionalInformation?: Record<string, unknown>
    ) {
        super(error, errorMessage);

        Object.setPrototypeOf(this, FatalErrorWithCustomMessage.prototype);

        if (doNotLog) {
            sentryShouldIgnoreError(this);
        }
    }

    public getFormattedMessage(): Array<import('react').ReactNode> {
        return this.message.split('\r\n');
    }
}